import React from 'react';
import PropTypes from 'prop-types';

import createComponent from 'components/core/createComponent';
import { defaultsDeep } from 'lodash';

import JBImage from 'components/essentials/JBImage';
import container from './container';

const ImageHalfTextLeft = props => {
  const configWithDefaults = defaultsDeep(props.config, {
    'main-image': {
      options: {},
    },
    'main-title': {
      options: {},
    },
  });

  return (
    <div data-xc="D-M1" className="flex flex-wrap flex-row items-stretch">
      <div className="basis-full sm:basis-1/3 min-w-0 h-[65vh] flex flex-col justify-center px-16 py-8 max-[1200px]:p-8">
        <h2
          className="text-xs font-bold tracking-[.04em] text-gray mt-0 mx-0 mb-[.4rem] uppercase"
          data-name="main-subtitle"
          data-xc="main-subtitle"
        >
          {configWithDefaults['main-subtitle'].value || null}
        </h2>

        <h1
          className="text-[2.375rem] leading-[2.375rem] tracking-[-.02em] mt-0 mx-0 mb-[1.1rem] font-normal text-gray"
          data-name="main-title"
          data-xc="main-title"
        >
          {configWithDefaults['main-title'].value || null}
        </h1>

        <p className="font-normal text-gray text-base leading-[1.5rem]">
          {configWithDefaults['main-text'].value || null}
        </p>
      </div>

      <div className="min-sm:basis-[66.66667%] min-sm:min-w-0 basis-full min-w-0 ">
        <div className="h-[65vh] media media-img [&_img]:h-full [&_img]:w-full [&_img]:object-cover">
          <JBImage
            src={configWithDefaults['left-image'].value || null}
            data-left="left-image"
            data-xc="left-image"
          />
        </div>
      </div>
    </div>
  );
};

ImageHalfTextLeft.propTypes = {
  config: PropTypes.object,
};

export default createComponent(ImageHalfTextLeft, container);
